import type { PeTrajectoryPoint, ScoreUnit } from '../../types';

export interface ChartPoint {
  schoolYear: string;
  value: number;
}

export interface WidaTrajectoryViewModel {
  priorScalePoints: ChartPoint[];
  currentScalePoints: ChartPoint[];
  spansReset: boolean;
}

export function buildWidaTrajectory(
  points: PeTrajectoryPoint[],
  unit: ScoreUnit,
): WidaTrajectoryViewModel {
  const priorScalePoints: ChartPoint[] = [];
  const currentScalePoints: ChartPoint[] = [];

  for (const point of points) {
    const chartPoint: ChartPoint = {
      schoolYear: point.school_year,
      value: unit === 'scale_score' ? point.average_scale_score : point.average_proficiency_level,
    };
    if (point.reset_era === 'post_reset') {
      currentScalePoints.push(chartPoint);
    } else {
      priorScalePoints.push(chartPoint);
    }
  }

  return {
    priorScalePoints,
    currentScalePoints,
    spansReset: priorScalePoints.length > 0 && currentScalePoints.length > 0,
  };
}
